import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

function getWeekDateRange(year, weekNumber) {
  const start = dayjs().year(year).isoWeek(weekNumber).startOf("isoWeek");
  const end = start.endOf("isoWeek");
  return `${start.format("MMM D")} - ${end.format("MMM D")}`;
}

function Isoweeks({ lastAvailableWeek }) {
  if (!lastAvailableWeek) return null;

  const weeks = Array.from({ length: 8 }, (_, i) => {
    const week = lastAvailableWeek.week - (7 - i);
    const year = lastAvailableWeek.year;

    const adjustedWeek = week > 0 ? week : 52 + week;
    const adjustedYear = week > 0 ? year : year - 1;

    return {
      week: adjustedWeek,
      year: adjustedYear,
      range: getWeekDateRange(adjustedYear, adjustedWeek),
    };
  });

  return (
    <Card sx={{ height: "100%" }}>
      <SoftBox pt={2} px={2}>
        <SoftTypography variant="h6">Weekly Ranges</SoftTypography>
      </SoftBox>
      <SoftBox p={2}>
        <Table sx={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              sx={{
                fontSize: "0.75rem",
                fontWeight: "bold",
                py: 0.5,
                pr: 6, // Increase right padding
              }}
            >
              Week Number
            </TableCell>
            <TableCell
              align="right"
              sx={{
                fontSize: "0.75rem",
                fontWeight: "bold",
                py: 0.5,
                pl: 10, // Increase left padding
              }}
            >
              Date Range
            </TableCell>
          </TableRow>
        </TableHead>
          <TableBody>
            {weeks.map(({ week, range }) => (
              <TableRow key={week}>
                <TableCell align="left" sx={{ fontSize: "0.75rem", py: 0.5 }}>Week {week}</TableCell>
                <TableCell align="left" sx={{ fontSize: "0.75rem", py: 0.5 }}>{range}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </SoftBox>
    </Card>
  );
}

export default Isoweeks;
